import { render } from "./readBydyw.vue?vue&type=template&id=1a65e5bb&scoped=true"
import script from "./readBydyw.vue?vue&type=script&lang=js"
export * from "./readBydyw.vue?vue&type=script&lang=js"

import "./readBydyw.vue?vue&type=style&index=0&id=1a65e5bb&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a65e5bb"]])

export default __exports__